import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import { GlobalHelper } from '../../../indexImports';
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceExportedToQuickBooksvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            proposal: this.props.proposal || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    isReturn() {
        return this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    getUrl() {
        if (this.isReturn()) {
            return this.getReturnUrl()
        }

        return this.getInvoiceUrl()
    }

    getInvoiceUrl() {
        let url = 'https://sandbox.qbo.intuit.com/app/invoice?txnId='
        if (AppContext.getOptions().environment === "prod") {
            url = 'https://qbo.intuit.com/app/invoice?txnId='
        }

        return url
    }

    getReturnUrl() {
        const paymentTransactions = this.state.invoice.attributes.paymentTransactions
        if (paymentTransactions.length === 0) {
            return ''
        }

        const mostRecentRefundTransaction = paymentTransactions[paymentTransactions.length - 1]
        if (mostRecentRefundTransaction.attributes.creditMemoId) {
            return this.getCreditMemoUrl()
        }

        return this.getRefundReceiptUrl()
    }

    getRefundReceiptUrl() {
        let url = 'https://sandbox.qbo.intuit.com/app/refundreceipt?txnId='
        if (GlobalHelper.isEnvProduction()) {
            url = 'https://qbo.intuit.com/app/refundreceipt?txnId='
        }

        return url
    }

    getCreditMemoUrl() {
        let url = 'https://sandbox.qbo.intuit.com/app/creditmemo?txnId='
        if (GlobalHelper.isEnvProduction()) {
            url = 'https://qbo.intuit.com/app/creditmemo?txnId='
        }

        return url
    }

    render() {
        const url = this.getUrl()

        let quickbooksUrl = url + this.state.object.attributes.externalId
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    {this.state.invoice.attributes.billingType !== BILLING_TYPE.RETURN ?
                        <FormattedMessage
                            id="invoice.analytics.events.exported.quickbooks.text"
                            defaultMessage="Invoice {identifier} has been exported to QuickBooks as an Invoice"
                            values={{
                                identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            }}
                        /> :
                        <FormattedMessage
                            id="invoice.analytics.events.exported.quickbooks.text.return"
                            defaultMessage="Return {identifier} has been exported to QuickBooks as an Invoice"
                            values={{
                                identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            }}
                        />
                    }
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={quickbooksUrl} target="_blank">
                        <img src="/images/quickbooks_logo.png" width="175px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={quickbooksUrl} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.quickbooks.open"
                                defaultMessage="Open sale in QuickBooks"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default InvoiceExportedToQuickBooksvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-quick-books.component.jsx